import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  label: {
    margin: theme.spacing(0, 0, 1),
  },
  loading: {
    verticalAlign: '-.25em',
    margin: theme.spacing(0, 0, 0, 1),
  },
}));
